import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  basePrice: number;
  className?: string;
}
export function PriceDisplay({
  basePrice,
  className = ''
}: PriceDisplayProps) {
  const [currency, setCurrency] = useState<{
    symbol: string;
    code: string;
  }>({
    symbol: '$',
    code: 'MXN'
  });
  useEffect(() => {
    // Detect user's locale from browser
    const locale = navigator.language || 'es-MX';
    // Map locales to currencies (Shopify Markets behavior)
    const currencyMap: Record<string, {
      symbol: string;
      code: string;
    }> = {
      'es-MX': {
        symbol: '$',
        code: 'MXN'
      },
      'es-AR': {
        symbol: 'ARS$',
        code: 'ARS'
      },
      'es-ES': {
        symbol: '€',
        code: 'EUR'
      },
      'en-GB': {
        symbol: '£',
        code: 'GBP'
      },
      'en-US': {
        symbol: '$',
        code: 'USD'
      }
    };
    // Find matching currency or default to MXN
    const detectedCurrency = currencyMap[locale] || currencyMap[locale.split('-')[0]] || currencyMap['es-MX'];
    setCurrency(detectedCurrency);
  }, []);
  return <div className={className} data-id="element-91">
      <div className="flex items-center justify-center gap-2" data-id="element-92">
        <span className="text-3xl md:text-4xl text-pink-600 font-bold" data-id="element-93">
          {currency.symbol}
        </span>
        <span className="text-6xl md:text-8xl text-rose-500 font-extrabold leading-none" data-id="element-94">
          {basePrice.toLocaleString()}
        </span>
      </div>
      <p className="text-lg md:text-xl text-stone-600 font-bold mt-2" data-id="element-95">
        {currency.code} - Pago único
      </p>
    </div>;
}